import { c as _c } from "react/compiler-runtime";
import { AFFILIATE_PROGRAM_API } from 'modules/affiliate-program/api/affiliate-program-api';
import { AffiliateFilterInterface, AffiliateStatsInterface } from 'modules/affiliate-program/types/affiliate-program-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export function useAffiliateStatistic(t0) {
  const $ = _c(7);
  const {
    filter
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const filterApi = `${filter.dateSince ? `?filter[dateSince]=${filter.dateSince}` : ""}${filter.dateTill ? `&filter[dateTill]=${filter.dateTill}` : ""}`;
  let t2;
  if ($[1] !== filter.dateSince || $[2] !== filterApi || $[3] !== user) {
    t2 = () => {
      if (user && filter.dateSince !== null) {
        return `${AFFILIATE_PROGRAM_API}/index${filterApi}`;
      }
      return null;
    };
    $[1] = filter.dateSince;
    $[2] = filterApi;
    $[3] = user;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: affiliateStatistic
  } = useSWR(t2, fetcher);
  let t3;
  if ($[5] !== affiliateStatistic) {
    t3 = {
      affiliateStatistic
    };
    $[5] = affiliateStatistic;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}